import React from 'react';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import App from '../App';
import CompanyRegistration from '../pages/CompanyRegistration';
import ContractRegistration from '../pages/ContractRegistration';
import ContractListPage from '../pages/ContractList';
import Login from '../pages/Login';
import QuestionsPage from '../pages/Questions';
import QuestionnairePage from '../pages/Questionnaire';
import QuestionnaireRegistration from '../pages/QuestionnaireRegistration';
import QuestionnaireListPage from '../pages/QuestionnaireList';
import UserRegistration from '../pages/UserRegistration';
import UserListPage from '../pages/UserList';
import CompanySelection from '../pages/CompanySelection';
import FrameworkRegistration from '../pages/FrameworkRegistration';
import ControlDomains from '../pages/ControlDomains';
import QuestionsListPage from '../pages/QuestionsList';
import AnswerQuestionnairePage from '../pages/AnswerQuestionnaire';
import CompanyListPage from '../pages/CompanyList';
import FrameworkListPage from '../pages/FrameworkList';
import DashboardPage from '../pages/Dashboard';
import PersonRegistration from '../pages/PersonRegistration';
import PersonListPage from '../pages/PersonList';
import EstruturaOrganizacional from '../pages/EstruturaOrganizacional';
import EstruturaOrganizacionalList from '../pages/EstruturaOrganizacionalList';
import PerfisAcesso from '../pages/PerfisAcesso';
import CadastrosAuxiliaresPage from '../pages/CadastrosAuxiliares';
import PublicAcesso from '../pages/PublicAcesso';
import RelatoriosListPage from '../pages/RelatoriosList';
import RelatorioAuditoriaPage from '../pages/RelatorioAuditoria';
import RelatorioPlanosAcaoPage from '../pages/RelatorioPlanosAcao';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Login />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/selecionar-empresa',
    element: <CompanySelection />,
  },
  {
    // Rota PÚBLICA (sem login): terceiro/fornecedor acessa o questionário pelo link do e-mail.
    path: '/acesso/:token',
    element: <PublicAcesso />,
  },
  {
    path: '/app',
    element: <App />,
    children: [
      {
        path: 'dashboard',
        element: <DashboardPage />,
      },
      {
        path: 'empresas',
        element: <CompanyRegistration />,
      },
      {
        path: 'empresas/list',
        element: <CompanyListPage />,
      },
      {
        path: 'empresas/visualizar/:id',
        element: <CompanyRegistration />,
      },
      {
        path: 'empresas/editar/:id',
        element: <CompanyRegistration />,
      },
      {
        path: 'contratos',
        element: <ContractRegistration />,
      },
      {
        path: 'contratos/list',
        element: <ContractListPage />,
      },
      {
        path: 'contratos/visualizar/:id',
        element: <ContractRegistration />,
      },
      {
        path: 'contratos/editar/:id',
        element: <ContractRegistration />,
      },
      {
        path: 'usuarios',
        element: <UserRegistration />,
      },
      {
        path: 'usuarios/list',
        element: <UserListPage />,
      },
      {
        path: 'usuarios/:id',
        element: <UserRegistration />,
      },
      {
        path: 'perfis-acesso',
        element: <PerfisAcesso />,
      },
      {
        path: 'pessoas',
        element: <PersonRegistration />,
      },
      {
        path: 'pessoas/list',
        element: <PersonListPage />,
      },
      {
        path: 'pessoas/:id',
        element: <PersonRegistration />,
      },
      {
        path: 'perguntas',
        element: <QuestionsPage />,
      },
      {
        path: 'perguntas/list',
        element: <QuestionsListPage />,
      },
      {
        path: 'perguntas/editar/:id',
        element: <QuestionsPage />,
      },
      {
        path: 'questionarios',
        element: <QuestionnairePage />,
      },
      {
        path: 'questionarios/list',
        element: <QuestionnaireListPage />,
      },
      {
        path: 'questionarios/novo',
        element: <QuestionnaireRegistration />,
      },
      {
        path: 'questionarios/editar/:id',
        element: <QuestionnaireRegistration />,
      },
      {
        path: 'frameworks',
        element: <FrameworkRegistration />,
      },
      {
        path: 'frameworks/list',
        element: <FrameworkListPage />,
      },
      {
        path: 'frameworks/editar/:id',
        element: <FrameworkRegistration />,
      },
      {
        path: 'estrutura-organizacional',
        element: <EstruturaOrganizacional />,
      },
      {
        path: 'estrutura-organizacional/list',
        element: <EstruturaOrganizacionalList />,
      },
      {
        path: 'estrutura-organizacional/editar/:id',
        element: <EstruturaOrganizacional />,
      },
      {
        path: 'dominios',
        element: <ControlDomains />,
      },
      {
        path: 'relatorios',
        element: <RelatoriosListPage />,
      },
      {
        path: 'relatorios/auditoria/:questionarioId',
        element: <RelatorioAuditoriaPage />,
      },
      {
        path: 'relatorios/planos-acao/:questionarioId',
        element: <RelatorioPlanosAcaoPage />,
      },
      {
        path: 'questionario/responder/:id',
        element: <AnswerQuestionnairePage />,
      },
      {
        path: 'questionario/auditoria/:id',
        element: <AnswerQuestionnairePage modoAuditoria />,
      },
      {
        path: 'cadastros-auxiliares',
        element: <Navigate to="/app/cadastros-auxiliares/tipo-empresa" replace />,
      },
      {
        path: 'cadastros-auxiliares/:slug',
        element: <CadastrosAuxiliaresPage />,
      },
    ],
  },
]);

const AppRoutes: React.FC = () => {
  return <RouterProvider router={router} />;
};

export default AppRoutes;